export default __webpack_public_path__ + "static/artboard-anim-2-6eaab868d1159de54243aa58de41f597.webm";